<template>
  <div class="main-container">
    <div class="bread" v-if="!!$route.query.recommend">
      <router-link :to="{ name: 'Index' }">首页</router-link>
      <span class="slash">/</span>
      <router-link
        :to="{
          name: 'IndexRecommendNews',
          params: { id: $route.query.recommend },
          query: { title: $route.query.title },
        }"
      >
        {{ $route.query.title }}
      </router-link>
      <span class="slash">/</span>
      <span class="current">资讯详情</span>
    </div>
    <div class="bread" v-else>
      <router-link :to="{ name: 'News' }">新闻资讯</router-link>
      <span class="slash">/</span>
      <span class="current">资讯详情</span>
    </div>
    <div class="news-main">
      <div class="news-title">{{ news.title }}</div>
      <div>
        <span class="news-click">{{ news.click_rate }}次浏览</span>
        <span class="news-time">{{ news.created_at_str }}</span>
      </div>
      <Rich class="news-content" :value="news.content"></Rich>
    </div>
  </div>
</template>
<script>
export default {
  name: "NewsShow",
  data() {
    return {
      news: {},
    };
  },
  async created() {
    let id = this.$route.params.id;
    let news = await this.$http.post("/api/app/information/detail", {
      information_id: id,
    });
    news.created_at_str = new Date(parseInt(news.created_at) * 1000).format(
      "yyyy/MM/dd hh:mm",
    );
    let div = document.createElement("div");
    div.innerHTML = news.content;
    div.querySelectorAll("img").forEach(el => {
      el.removeAttribute("title");
    });
    news.content = div.innerHTML;
    this.news = news;
  },
};
</script>
<style lang="scss" scoped>
.bread {
  background-color: white;
  padding: 20px;
  margin-top: 30px;
  color: rgba(0, 0, 0, 0.45);
  margin-bottom: 30px;
  .slash {
    margin: 0 8px;
  }
  .current {
    color: #595959;
  }
}
.news-main {
  background-color: white;
  padding: 30px;
  margin-bottom: 50px;
}
.news-title {
  font-size: 20px;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.85);
  margin-bottom: 8px;
}
.news-click,
.news-time {
  font-size: 16px;
  color: rgba(140, 140, 140, 1);
  margin-right: 10px;
}
.news-content {
  padding-top: 25px;
}
</style>
